import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { TertiaryTitle } from '@xceedsrl/jukebox';
import { measures } from '../config/constants';
function SectionTitle(props) {
  return React.createElement(TertiaryTitle, _extends({
    wrapped: true,
    fontSize: measures.TITLE_FONT
  }, props));
}
export default React.memo(SectionTitle);